import React from 'react';
import { Shield, Brain, UserCheck, Users } from 'lucide-react';
import { motion } from 'framer-motion';
const values = [{
  icon: Shield,
  title: 'Confiance & discipline',
  description: "Développer l'assurance et le contrôle de soi."
}, {
  icon: Brain,
  title: 'Mise en forme & concentration',
  description: 'Un esprit sain dans un corps sain et actif.'
}, {
  icon: UserCheck,
  title: 'Encadrement professionnel',
  description: 'Des instructeurs certifiés et passionnés.'
}, {
  icon: Users,
  title: 'Tous les âges et niveaux',
  description: 'Un programme adapté à chaque membre de la famille.'
}];
export function ValuesSection() {
  return <section className="py-20 bg-white" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-145">
          {values.map((value, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center p-6 rounded-2xl hover:bg-neutral-50 transition-colors duration-300" data-id="element-146">
              <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-6 text-red-600" data-id="element-147">
                <value.icon className="w-8 h-8" data-id="element-148" />
              </div>
              <h3 className="text-lg font-bold text-neutral-900 mb-2" data-id="element-149">
                {value.title}
              </h3>
              <p className="text-neutral-600 text-sm" data-id="element-150">{value.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}